/**
 * CR-1421: colours for the payment-terms split of the Cost weekly charts.
 *
 * A blue ramp, shortest terms darkest: the split divides the existing blue
 * "Total Incoming Value" bar, so it must not collide with the chart's red,
 * green and amber series (mockup 01).
 */
import type { CostTermsGroup } from '../../../lib/api'

const RAMP = ['#1e3a8a', '#1d4ed8', '#3b82f6', '#60a5fa', '#93c5fd', '#bfdbfe']
const OTHER = '#64748b'
const NOT_SET = '#cbd5e1'

/**
 * The fill for each terms group, keyed by group key.
 * @param groups - the response's terms groups, in display order
 * @returns group key → hex colour
 */
export function termsColours(groups: CostTermsGroup[]): Record<string, string> {
  const out: Record<string, string> = {}
  let i = 0
  for (const g of groups) {
    if (g.key === 'none') out[g.key] = NOT_SET
    else if (g.key === 'other') out[g.key] = OTHER
    else out[g.key] = RAMP[Math.min(i++, RAMP.length - 1)]
  }
  return out
}

/** The recharts data key holding one group's value on a week row. */
export const termsDataKey = (key: string) => `t_${key}`
